import React, { Suspense, lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import './App.css';

// Lazy load non-critical pages
const LoginPage = lazy(() => import('./pages/LoginPage'));
const OAuth2Redirect = lazy(() => import('./pages/OAuth2Redirect'));
const JobDetailPage = lazy(() => import('./pages/JobDetailPage'));
const JobCreatePage = lazy(() => import('./pages/JobCreatePage'));
const MyPage = lazy(() => import('./pages/MyPage'));
const ResumePage = lazy(() => import('./pages/ResumePage'));
const NotFoundPage = lazy(() => import('./pages/NotFoundPage'));

const PageLoader = () => (
  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '40vh' }}>
    <div style={{ width: 28, height: 28, border: '3px solid #e2e8f0', borderTopColor: '#2563eb', borderRadius: '50%', animation: 'spin .6s linear infinite' }} />
  </div>
);

function App() {
  return (
    <div className="App">
      <Header />
      <main className="main-content">
        <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/oauth2/redirect" element={<OAuth2Redirect />} />
            <Route path="/jobs/:id" element={<JobDetailPage />} />
            <Route path="/jobs/create" element={<JobCreatePage />} />
            <Route path="/jobs/:id/edit" element={<JobCreatePage />} />
            <Route path="/mypage" element={<MyPage />} />
            <Route path="/resumes" element={<ResumePage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </Suspense>
      </main>
      <Footer />
    </div>
  );
}

export default App;
